export const SERVICE_ORDER_STATUS_KEYS = {
  new: 'awaitingReview',
  awaiting_information: 'needsInfo',
  reviewing: 'reviewing',
  proposal_sent: 'proposalReady',
  awaiting_payment: 'awaitingPayment',
  in_progress: 'inProgress',
  client_review: 'clientReview',
  completed: 'completed',
  cancelled: 'cancelled',
};

export const SERVICE_ORDER_STATUS_TONES = {
  new: 'amber',
  awaiting_information: 'orange',
  reviewing: 'blue',
  proposal_sent: 'violet',
  awaiting_payment: 'rose',
  in_progress: 'cyan',
  client_review: 'indigo',
  completed: 'green',
  cancelled: 'gray',
};

export const PAYMENT_STATUS_KEYS = {
  not_required: 'notRequired',
  unpaid: 'unpaid',
  partially_paid: 'partial',
  paid: 'paid',
  refunded: 'refunded',
};

/** @deprecated Prefer statusInfoLocalized(status, t) */
export const SERVICE_ORDER_STATUSES = {
  new: { label: 'در انتظار بررسی', tone: 'amber' },
  awaiting_information: { label: 'نیازمند اطلاعات', tone: 'orange' },
  reviewing: { label: 'در حال بررسی', tone: 'blue' },
  proposal_sent: { label: 'پیشنهاد قیمت آماده', tone: 'violet' },
  awaiting_payment: { label: 'در انتظار پرداخت', tone: 'rose' },
  in_progress: { label: 'در حال انجام', tone: 'cyan' },
  client_review: { label: 'تحویل برای بازبینی', tone: 'indigo' },
  completed: { label: 'تکمیل‌شده', tone: 'green' },
  cancelled: { label: 'لغوشده', tone: 'gray' },
};

export const statusInfo = (status) => SERVICE_ORDER_STATUSES[status] || { label: status || 'نامشخص', tone: 'gray' };

export const statusInfoLocalized = (status, t) => {
  const key = SERVICE_ORDER_STATUS_KEYS[status];
  return {
    label: key
      ? t(`customerUi.orderStatuses.${key}`)
      : (status || t('customerUi.orderStatuses.unknown')),
    tone: SERVICE_ORDER_STATUS_TONES[status] || 'gray',
  };
};

export const formatServiceOrderAmount = (amount, localeCode = 'fa-IR') => (
  Number(amount || 0).toLocaleString(localeCode)
);

/** @deprecated Prefer paymentStatusLabelLocalized(status, t) */
export const PAYMENT_STATUS_LABELS = {
  not_required: 'پرداخت پس از بررسی',
  unpaid: 'پرداخت‌نشده',
  partially_paid: 'بخشی پرداخت‌شده',
  paid: 'تسویه‌شده',
  refunded: 'بازگشت وجه',
};

export const paymentStatusLabel = (status) => PAYMENT_STATUS_LABELS[status] || 'نامشخص';

export const paymentStatusLabelLocalized = (status, t) => {
  const key = PAYMENT_STATUS_KEYS[status];
  return key
    ? t(`customerUi.paymentStatuses.${key}`)
    : t('customerUi.orderStatuses.unknown');
};

export const nextServicePaymentStage = (order, now = new Date()) => (
  order?.paymentSchedule?.installments?.find((item) => {
    if (['pending', 'failed'].includes(item.status)) return true;
    if (item.status !== 'processing' || !item.requestedAt) return false;
    return new Date(now).getTime() - new Date(item.requestedAt).getTime() > 20 * 60 * 1000;
  }) || null
);

export const nextServiceInstallment = nextServicePaymentStage;

export const formatServiceOrderDate = (value, options = {}, localeCode = 'fa-IR') => {
  if (!value) return '—';
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return '—';
  return date.toLocaleDateString(localeCode, { year: 'numeric', month: 'long', day: 'numeric', ...options });
};

export const serviceOrderId = (order) => order?.orderNumber || String(order?._id || '').slice(-8).toUpperCase();
